import anime from 'animejs'
import { getAll } from '@bigyouth/base'
import withResponsive from '../hoc/withResponsive'
import emitter from '../utils/emitter'

const INITAL_SETTERS = {
  default: () => {},
  fadeIn: target => {
    const targets = getAll('[js-scroll-animations-target]', target)
    targets.forEach(image => {
      image.style.opacity = 0
    })
  },
  translateFadeIn: target => {
    const targets = getAll('[js-scroll-animations-target]', target)
    targets.forEach(image => {
      image.style.opacity = 0
    })
  },
}

const ANIMATIONS = {
  default: () => {},
  fadeIn: target => {
    const targets = getAll('[js-scroll-animations-target]', target)

    anime({
      targets,
      opacity: 1,
      duration: 1000,
      delay: (el, i, l) => i * 150,
      easing: 'easeOutCubic',
    })
  },
  translateFadeIn: target => {
    const targets = getAll('[js-scroll-animations-target]', target)

    const classTargets = getAll('[js-scroll-animations-class-target]', target)

    classTargets.forEach(target => {
      target.classList.add('is-active')
    })

    anime({
      targets,
      opacity: 1,
      translateY: ['60px', 0],
      scaleY: [1.05, 1],
      duration: 1000,
      delay: (el, i, l) => i * 250,
      easing: 'easeOutCubic',
    })
  },
}

/**
 * ScrollAnimations manage all the animations launched when a target enter the screenview.
 *
 * js-scroll-animations should should be added on the parent containing all the targets.
 * js-scroll-animations-area="[ID]" should be added on all the targeted areas. [ID] is optional, if none is specified, 'default' animation is launched.
 */
export default withResponsive({
  name: 'scroll-animations',

  ui: {
    'areas[]': '[js-scroll-animations-area]',
  },

  scriptsViewed: false,

  componentDidMount () {
    const observerOptions = {
      root: null,
      rootMargin: '-50% 0px -40% 0px',
      threshold: 0.0,
    }

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const animationId =
            entry.target.getAttribute('js-scroll-animations-area') || 'default'
          const animationFunction =
            ANIMATIONS[animationId] || ANIMATIONS.default

          if (!entry.target.classList.contains('trigger-autoplay')) {
            observer.unobserve(entry.target)
            animationFunction(entry.target)
          } else {
            emitter.trigger('autoPlayScriptAnim', { activeTab: document.querySelector('.tab-script.is-active').dataset.tab })

            if (!this.scriptsViewed && this.props.noAnim === undefined) {
              animationFunction(entry.target)
            }

            this.scriptsViewed = true
          }
        } else {
          if (entry.target.classList.contains('trigger-autoplay')) {
            emitter.trigger('stopScriptAnim')
          }
        }
      })
    }

    const observer = new IntersectionObserver(observerCallback, observerOptions)

    setTimeout(() => {
      this.ui.areas.forEach((target) => {
        if (this.props.noAnim === undefined) {
          const animationId =
            target.getAttribute('js-scroll-animations-area') || 'default'
          const initialSetter =
            INITAL_SETTERS[animationId] || INITAL_SETTERS.default

          initialSetter(target)
        }

        observer.observe(target)
      })
    }, 300)
  },
})
